import { render, staticRenderFns } from "./DialogUpdateDriver.vue?vue&type=template&id=442d352e&"
import script from "./DialogUpdateDriver.vue?vue&type=script&lang=js&"
export * from "./DialogUpdateDriver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('442d352e')) {
      api.createRecord('442d352e', component.options)
    } else {
      api.reload('442d352e', component.options)
    }
    module.hot.accept("./DialogUpdateDriver.vue?vue&type=template&id=442d352e&", function () {
      api.rerender('442d352e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogUpdateDriver.vue"
export default component.exports